// src/components/KakaoChatButton.tsx
import { useRef, type FC } from "react";
import { MessageCircle } from "lucide-react";
import "../styles/kakao-chat.css";
import {
  getKakaoChatUrl,
  isValidKakaoPfUrl,
  openExternalUrl,
} from "../lib/openExternal";

const KakaoChatButton: FC = () => {
  const lastTapRef = useRef(0);

  const onClick = () => {
    const now = Date.now();
    if (now - lastTapRef.current < 600) return;
    lastTapRef.current = now;

    const url = getKakaoChatUrl();

    if (!isValidKakaoPfUrl(url)) {
      alert("카카오톡 채널 주소가 잘못 설정되어 있습니다. 관리자에게 문의해 주세요.");
      return;
    }

    openExternalUrl(url);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className="jp-kakao-chat"
      aria-label="카카오톡 채널로 문의하기"
    >
      <span className="jp-kakao-chat-icon" aria-hidden="true">
        <MessageCircle size={19} fill="currentColor" strokeWidth={1.5} />
      </span>
      <span>카카오톡 상담</span>
    </button>
  );
};

export default KakaoChatButton;
